import { observer } from 'mobx-react-lite'
import { Type, Typography } from 'shared/ui'
import { type IColumn, EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type HubspotWorkflowRow } from 'entities/HubspotWorkflows/model/HubspotWorkflowRow'
import styles from './styles.module.scss'

export const getColumns = (): IColumn<HubspotWorkflowRow>[] => {
  return [
    {
      field: 'name',
      name: 'Name',
      width: '100%',
      minWidth: 400,
      renderRowCell: (row) => <NameCell row={row} />,
      isDisabledChangeVisible: true,
    },
    {
      field: 'first_message_date',
      name: 'First message',
      renderRowCell: (row) =>
        row.firstMessageDate ? (
          uiStore.dayjs(row.firstMessageDate).format(DayjsFormats.fullWithAtDash2)
        ) : (
          <EmptyCell />
        ),
    },
    {
      field: 'type',
      name: 'Type',
      renderRowCell: () => <Type type={'sms'} />,
    },
    {
      field: 'total',
      name: 'Total messages',
      renderRowCell: (row) => row.total,
    },
  ]
}

const NameCell = observer(({ row }: { row: HubspotWorkflowRow }) => (
  <div className={styles.cellWrapper}>
    <Typography
      variant={'body-md-regular'}
      ellipsis
      tooltipProps={{
        label: row.name,
        fullWidth: true,
        breakWord: true,
      }}
      ariaLabel={'name'}
    >
      {row.name || row.workflowId}
    </Typography>
  </div>
))
